import React from 'react';
import {Constants} from '../../../oauth/helpers/constants';

import PageLoader from '../../page-loader';
import '../../../index.scss';
import {useRedirectUrl} from '../../../contexts/RedirectUrlContext';

export const LogoutCallback = () => {
  const {redirectUrl} = useRedirectUrl();

  const getRedirectcUrl = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const paramState = urlSearchParams.get('state') || '';
    let redirectUrlAux: any;

    if (paramState.includes('true')) {
      redirectUrlAux = `${Constants.clientRoot}/registo`;
    } else if (paramState) {
      redirectUrlAux = redirectUrl || Constants.clientRoot;
    } else {
      redirectUrlAux = Constants.clientRoot;
    }
    return redirectUrlAux;
  };

  getRedirectcUrl().then((response) => {
    window.location.replace(response);
  });

  return (
    <div className="loading-page-container">
      <PageLoader />
    </div>
  );
};
